import styled, { keyframes } from 'styled-components'

const blinkAnimation = keyframes`
  0% { filter: grayscale(100%); }
  5% { filter: grayscale(90%); }
  10% { filter: grayscale(80%); }
  15% { filter: grayscale(70%); }
  20% { filter: grayscale(60%); }
  25% { filter: grayscale(50%); }
  30% { filter: grayscale(40%); }
  35% { filter: grayscale(30%); }
  40% { filter: grayscale(20%); }
  45% { filter: grayscale(10%); }
  50% { filter: none; }
  55% { filter: grayscale(10%); }
  60% { filter: grayscale(20%); }
  65% { filter: grayscale(30%); }
  70% { filter: grayscale(40%); }
  75% { filter: grayscale(50%); }
  80% { filter: grayscale(60%); }
  85% { filter: grayscale(70%); }
  90% { filter: grayscale(80%); }
  95% { filter: grayscale(90%); }
  100% { filter: grayscale(100%); }
`

export const StyledSVG = styled.svg<{ disabled?: boolean }>`
  transition: all 300ms ease-in-out;

  &:not([disabled]) {
    cursor: pointer;
  }

  &[disabled] {
    filter: grayscale(100%);
    animation: ${blinkAnimation} 4s linear infinite;
  }
`
